const STORAGE_KEYS = {
  localStorage: ['oxygen_id'],
  sessionStorage: ['profile_redirect_url', 'retireSmsBanner', 'meMenuUser'],
};

const clearClientState = () => {
  STORAGE_KEYS.localStorage.forEach((key) => {
    window.localStorage.removeItem(key);
  });

  STORAGE_KEYS.sessionStorage.forEach((key) => {
    window.sessionStorage.removeItem(key);
  });

  if (window.digitalData?.user) {
    window.digitalData.user = {};
  }
};

export { STORAGE_KEYS };
export default clearClientState;
